export default function authHeader() {    
    const auth = JSON.parse(localStorage.getItem('auth'));

    if (auth && auth.session && auth.session.token) {        
        return { Authorization: 'Bearer ' + auth.session.token };
    } else {        
        return {};
    }
}